import React from 'react';
import LegalPageLayout from '../components/legal/LegalPageLayout';
import { termsOfService } from '../content/legalContent';
import { Box } from '@chakra-ui/react';
import { GlobalFooter } from '../components/ui/GlobalFooter';

const Terms: React.FC = () => {
  return (
    <>
      <LegalPageLayout title="Terms of Service">
        {termsOfService}
      </LegalPageLayout>
      <Box px={{ base: 4, md: 8 }} pb={8}>
        <GlobalFooter />
      </Box>
    </>
  );
};

export default Terms;
